'use strict';

/**
 * E9 portal commercial client helpers.
 */

import http from './httpService';
import { openPdf } from '../utils/downloadPdf';

export const AVAILABLE_CREDIT_HELP =
  'Available Credit is unapplied customer credit and may be used to settle future invoices.';

export function getWallet() {
  return http.get('/client/wallet');
}

export function getNextPaymentDue() {
  return http.get('/client/billing/next-due');
}

export function downloadStatementPdf(params = {}, filename) {
  const q = new URLSearchParams();
  if (params.from) q.set('from', params.from);
  if (params.to) q.set('to', params.to);
  const suffix = q.toString() ? `?${q.toString()}` : '';
  return openPdf(`/client/statement.pdf${suffix}`, filename || 'statement-of-account.pdf');
}
